export enum TicketStatus {
  RISK_TICKET = 1,
  ACCEPTED = 2,
  REJECTED = 3,
  PLACED = 4,
  CHANGED_TERMS_ON_TICKET = 5,
  STORNED = 6,
  FAILED = 7,
  PASSED = 8,
  PAYED = 9,
  VERIFICATION_IN_PROGRESS = 10,
  PRINTED = 11,
  PULLED = 12,
  CASHBACK = 13,
  CANCELED = 14,
  PAYED_CASHBACK = 15,
  PAYED_TURBO = 16,
  GIVE_UP = 17,
  AUTO_REJECTED = 18,
  EXPIRED = 19,
  PAYED_CASHOUT = 20,
  SKIP = 21,
  GAVE_UP = 22,
  RISK_CASHOUT = 23,
  PASSED_CASHOUT = 24,
}

export enum DefaultTicketStatus {
  RISK_TICKET = 1,
  ACCEPTED = 2,
  PLACED = 4,
  CHANGED_TERMS_ON_TICKET = 5,
  FAILED = 7,
  PASSED = 8,
  PAYED = 9,
  VERIFICATION_IN_PROGRESS = 10,
  PRINTED = 11,
  PULLED = 12,
  PAYED_CASHBACK = 15,
  PAYED_TURBO = 16,
  PAYED_CASHOUT = 20,
  RISK_CASHOUT = 23,
}

export enum PassedTicketStatus {
  PASSED = 8,
  PAYED = 9,
  PRINTED = 11,
  PAYED_CASHBACK = 15,
  PAYED_TURBO = 16,
  PAYED_CASHOUT = 20,
}

export enum TicketActions {
  SET_CASHBACK = 13,
  SET_PAYED_TURBO = 16,
  SET_STORNO = 6,
  PASSED = 8,
  PAYED_CASHOUT = 20,
}

export enum StornoReason {
  ON_CLIENTS_REQUEST = 1,
  ON_OPERATORS_REQUEST = 2,
  CHANGED_EVENT_LIMIT = 3,
}

export enum TicketType {
  CASH = 1,
  CREDIT = 2,
  TRANSFER = 3,
}






